var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"activity__cont"},[_c('p',[_vm._v(_vm._s(_vm.lastActivity))]),_vm._v(" "),_c('p',{staticClass:"activity__last-created-at"},[_vm._v(_vm._s(_vm.lastActivityAt))])])}
var staticRenderFns = []

export { render, staticRenderFns }